import { NotificationsAPI } from "./remoteAPI";
import { TimeToString } from "../Utils/DateFromater";

const Categories = {
    //
    "الأقساط المستحقة": 0,
    "مواد منتهية الصلاحية": 1,
    "المواد المحذوفة": 2,
    "الحسابات المحذوفة": 3,
    "قوائم الشراء المحذوفة": 4,
    "قوائم البيع المحذوفة": 5,
    "بكبات لم ترفع": 6,
};

const FormateNotification = (notifications) => {
    notifications.forEach((notification) => {
        notification.category = Categories[notification.category];
        notification.createdAt = TimeToString(notification.createdAt);
        notification.title = notification.title.length < 70 ? notification.title : `${notification.title.substring(0, 70)}...`;
    });
};

const Notifications = {
    getNotifications: (clear, notifications, setNotifications, setCanLoadMore, setIsLoading, businessId, category = -1) => {
        let offset = clear ? 0 : notifications.length;
        clear && setIsLoading(true);
        NotificationsAPI.get(`/business/?offset=${offset || 0}&all=true${businessId ? `&businessId=${businessId}` : ""}&category=${category}`)
            .then(({ data }) => {
                FormateNotification(data);
                setCanLoadMore(data.length > 24);
                clear ? setNotifications(data) : setNotifications([...notifications, ...data]);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                setCanLoadMore(false);
            });
    },

    markAllRead: () => NotificationsAPI.patch("/business"),
    getNotification: (id) => NotificationsAPI.get(`/business/${id}`),
    newNotificationsCount: (setNotificationCount) =>
        NotificationsAPI.get(`/business/count`).then((respons) => {
            let count = 0;
            respons.data?.forEach((element) => (count += element.count));
            count > 0 && setNotificationCount(count);
        }),
    markRead: (id) => NotificationsAPI.patch(`/business/${id}`, { read: true }),
    sendToken: (token) => NotificationsAPI.post("/tokens", { tokens: [token] }).then(() => localStorage.setItem("pushToken", token)),
    deleteToken: async (token) => await NotificationsAPI.delete(`/tokens/${token}`),
    deleteAllTokens: async () => await NotificationsAPI.delete("/tokens"),
};

export default Notifications;
